export function triggerBrandSearch(setIsSearching, setBrandSearchKey) {
    return (value) => {
        setIsSearching(true)
        setBrandSearchKey(value)
    };
}
